import { render, staticRenderFns } from "./SmRadio.vue?vue&type=template&id=25305984&scoped=true&"
import script from "./SmRadio.vue?vue&type=script&lang=ts&"
export * from "./SmRadio.vue?vue&type=script&lang=ts&"
import style0 from "./SmRadio.vue?vue&type=style&index=0&id=25305984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25305984",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
